import { render, staticRenderFns } from "./DeliveryIncentives.vue?vue&type=template&id=1702d931&"
import script from "./DeliveryIncentives.vue?vue&type=script&lang=js&"
export * from "./DeliveryIncentives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports